module.exports = __webpack_public_path__ + "img/4-2-south-1.74182bdb.jpg";